import React from "react";
import {
  FiHeart,
  FiShield,
  FiStar,
  FiSmile,
} from "react-icons/fi";
import founderImg from "../assets/img/founder.jpeg"; // 👈 Replace with your founder image

function Founder() {
  return (
    <section className="founder-section">
      <div className="container founder-container">
        {/* Founder Image */}
        <div className="founder-photo">
          <img src={founderImg} alt="Founder" />
        </div>

        {/* Founder Content */}
        <div className="founder-info">
          <h2 className="founder-title">
            Meet Our <span>Founder</span>
          </h2>
          <p className="founder-name">Mr. Ahtesham Ali</p>
          <p className="founder-role">Founder & Visionary</p>

          <p className="founder-description">
            With a vision to bring hearts together, Mr. Rajesh established this
            platform to create meaningful and lifelong connections. His passion
            for fostering trust, authenticity, and happiness drives our mission
            to help people find their perfect life partners.
          </p>

          <div className="founder-highlights">
            <div className="highlight-card">
              <FiHeart className="icon" />
              <span>Empowering Love Stories</span>
            </div>
            <div className="highlight-card">
              <FiShield className="icon" />
              <span>Trusted & Secure Network</span>
            </div>
            <div className="highlight-card">
              <FiStar className="icon" />
              <span>10+ Years of Experience</span>
            </div>
            <div className="highlight-card">
              <FiSmile className="icon" />
              <span>Thousands of Happy Matches</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Founder;
